import { Dimmer, Grid, Header, Icon, Loader, SectionItem, Tooltip } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import ModesReglementInput from '@/components/ConstitutionRegie/ModesReglement/ModesReglement';
import { MODES_REGLEMENTS } from '@/constants';
import { LoadingContext } from '@/contexts';
import type { RegieModeReglement } from '@/types/regie';

interface RegisseursProps {
  identifiant: string | number;
  depotFondTresor?: boolean;
  modesReglements?: RegieModeReglement[];
  onChange?: (e: any) => void;
}

const ModesReglement = (props: RegisseursProps) => {
  const { identifiant, depotFondTresor, modesReglements, onChange } = props;

  const {
    modesReglementsLoadings: {
      modesReglements: modesReglementLoading,
      regieModesReglement: regieModesReglementLoading,
    },
  } = React.useContext(LoadingContext);

  const loadingModesReglement = React.useMemo(
    () => modesReglementLoading || regieModesReglementLoading,
    [modesReglementLoading, regieModesReglementLoading],
  );

  const handleModesChange = React.useCallback(
    (modes) => {
      const hasPrelevement = _.some(modes, { code: MODES_REGLEMENTS.PRELEVEMENT });

      if (onChange) {
        onChange({
          identifiant,
          modesReglements: modes,
          ...(hasPrelevement && { depotFondTresor: true }),
        });
      }
    },
    [identifiant, onChange],
  );

  const headerModesReglement = React.useMemo(
    () => (
      <Header size="small">
        Modes de règlement autorisés par la régie
        <Tooltip
          type="warning"
          trigger={
            <Icon
              name="Info"
              iconSet="Lucide"
              size={22}
              style={{ position: 'absolute', right: '-1em' }}
            />
          }
          message={
            <div style={{ width: 400 }}>
              Les modes de règlement autorisés par la régie apparaissent dans cet ordre dans la
              fenêtre d&apos;encaissement des factures.
            </div>
          }
          position="bottom center"
        />
      </Header>
    ),
    [],
  );

  return (
    <Grid stackable relaxed>
      <Grid.Row style={{ paddingTop: 0 }}>
        <Grid.Column style={{ paddingLeft: 0 }}>
          <SectionItem single compact titleRenderer={() => headerModesReglement}>
            {loadingModesReglement ? (
              <div style={{ height: 50 }}>
                <Dimmer active inverted>
                  <Loader>Chargement des modes de règlement...</Loader>
                </Dimmer>
              </div>
            ) : (
              <ModesReglementInput
                onChange={handleModesChange}
                depotFondTresor={depotFondTresor}
                modesReglements={modesReglements}
              />
            )}
          </SectionItem>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ModesReglement;
